export const priceObj = {
  id: "Pricing",
  headline: "Affordable and transparent pricing. ",
  buttonLabel: "See Full Pricing List",
  imgStart: true,
  img: require("../../Assets/Images/Price-pic.png").default,
  alt: "Customers buying goods",
};
